<template>
  <div :class="containerClass" class="text-xs md:text-sm lg:text-md">
    <svg class="stroke-current w-5 h-5 md:w-8 md:h-8 mr-1 md:mr-3" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-miterlimit="10" transform="translate(.5 .5)"><circle cx="10.047" cy="10.047" r="10.047"/><path d="M10.047 0v3.257M10.047 16.837v3.257M20.094 10.047h-3.257M3.257 10.047H0M13.668 6.425l-3.621 3.621 4.64 4.64"/></g></svg>
    {{content}}
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      required: true,
    },
    containerClass: {
      type: String,
      required: false,
    },
  },
};
</script>

<style>

</style>
